import { AppState } from '../root.reducer';
import { AttributeType } from '../saved-company/saved-company.models';

export const cartSelector = (state: AppState) => state.cart.cart;

export const isItemInCartSelector = (attributeType: AttributeType, attributeId: number) => (state: AppState) => 
  state.cart.cart.items.findIndex(i => i.attributeType === attributeType && i.attributeId === attributeId) > -1;

export const cartSubmissionStateSelector = (state: AppState) => state.cart.submissionState;